// Skills Icons
import htmlIcon from "./images/html.svg"
import cssIcon from "./images/css.svg"
import reactIcon from "./images/react.svg"
import jsIcon from "./images/javascript.svg"
import codeIcon from "./images/code.svg"
import dynamics from "./images/dynamics.svg"

// Social Icon
import githubIcon from "./images/github.svg"
import twitterIcon from "./images/twitter.svg"
import linkedInIcon from "./images/linkedin.svg"
import instagramIcon from "./images/instagram.svg"

//my image
import pic from "./images/tobi.png"
// project images
import iplug from "./images/iplug.png"
import proxsure from "./images/proxsure-pic.png"
import neighborhoodmap from "./images/neighborhood-map.png"

export default {
  //(Please Do Not Remove The comma(,) after every variable)
  //Change The Website Template

  //   Header Details ---------------------
  name: "Oluwatobi",
  headerTagline: [
    //Line 1 For Header
    "Building digital",
    //Line 2 For Header
    "products, brands,",
    //Line 3 For Header
    "and experience",
  ],
  //   Header Paragraph
  headerParagraph: ``,

  //Contact Email
  contactEmail: "tobioyewole25@gmail.com",

  // End Header Details -----------------------

  // Work Section ------------------------
  projects: [
    {
      id: 1, //DO NOT CHANGE THIS (Please)😅
      title: "IPlug Website", //Project Title - Add Your Project Title Here
      para: "An ECommerce Website for purchasing apple products online", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc: iplug,
      //Project URL - Add Your Project Url Here
      url: "https://www.iplug.ng/",
    },
    {
      id: 2, //DO NOT CHANGE THIS (Please)😅
      title: "Mentoring App", //Project Title - Add Your Project Title Here
      para:
        "Web App for proving Mentoring Services to Mentees, Fresh Graduates in the Industry", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc: proxsure,
      //Project URL - Add Your Project Url Here
      url: "https://staging.app.proxsure.com/",
    },
    {
      id: 3, //DO NOT CHANGE THIS (Please)😅
      title: "Neighbourhood Map", //Project Title - Add Your Project Title Here
      para:
        "Use the Google Maps API to Displays locations of Areas within Lekki, Lagos State, Nigeria", // Add Your Service Type Here
      //Project Image - Add Your Project Image Here
      imageSrc: neighborhoodmap,
      //Project URL - Add Your Project Url Here
      url: "https://react-neighborhood-map.netlify.app",
    },
  ],

  // End Work Section -----------------------

  // About Secton --------------
  aboutParaOne: `A highly motivated Front-End
    Engineer and Business Intelligence
    Analyst with four (4) years of work
    experience building & operating web
    applications, providing insights from
    data gathered to improve customer /
    user’s experience. Looking to
    leverage my knowledge and
    experience into the role as a
    Software Engineer.`,
  aboutParaTwo: "",
  aboutParaThree: "",
  aboutImage: pic,

  //   End About Section ---------------------

  // Skills Section ---------------

  //   Import Icons from the top and link it here

  skills: [
    {
      id: 1,
      img: htmlIcon,
      para: `Create text, paragraphs, attach images, give structure, and make web pages presentable and appealing using Hypertext Markup Language (HTML)`,
    },
    {
      id: 2,
      img: cssIcon,
      para: `
      Using CSS to handle the look and feel part of a web page,control the color of the text, the style of fonts, the spacing between paragraphs, how columns are sized and laid out, what background images or colors are used, layout designs,variations in display for different devices and screen sizes as well as a variety of other effects.`,
    },
    {
      id: 3,
      img: jsIcon,
      para: `Using javascirpt to implement the front-end logic that defines the behavior of the visual elements of a web application and connecting this with the services that reside on the back-end. `,
    },
    {
      id: 4,
      img: reactIcon,
      para: `Design and implement user interface components for JavaScript-based web and mobile applications using the React open source library ecosystem`,
    },
    {
      id: 5,
      img: dynamics,
      para: `Development and maintenance of the internal Microsoft Dynamics 365 CRM platform,sound knowledge in Dynamics CRM entities, workflows, configurations, customization development, integration development, reporting, dashboards.`,
    },
    {
      id: 6,
      img: codeIcon,
      para: `Writing computer programs for software and mobile apps.
      Develop and deploy computer applications. Execute code builds to test and production environments. Fix bugs in existing code.`,
    },
  ],

  // End Skills Section --------------------------

  //   Promotion Section --------------------------

  promotionHeading: "Heading",
  promotionPara:
    "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.",
  // End Promotion Section -----------------

  //   Contact Section --------------

  contactSubHeading: "Let's create your next experience together",
  social: [
    // Add Or Remove The Link Accordingly
    { img: githubIcon, url: "https://github.com/tobi-oye" },
    {
      img: twitterIcon,
      url: "https://twitter.com/_Thorby/",
    },
    {
      img: linkedInIcon,
      url: "https://www.linkedin.com/in/oyewole-oluwatobi-70b892104/",
    },
    {
      img: instagramIcon,
      url: "https://www.instagram.com/",
    },
  ],

  // End Contact Section ---------------
}

// Thanks for using this template, I would love to hear from you contact me at hello@chetanverma.com
